/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_AcknowledgementInputs */

const en_directory_promotion_acknowledgement = /** @type {(inputs: Directory_Promotion_AcknowledgementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand that this is a UI-only preview. Campaign inventory, payments, and publishing will be connected after the operating model is finalized.`)
};

const zh_directory_promotion_acknowledgement = /** @type {(inputs: Directory_Promotion_AcknowledgementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我了解这只是 UI 预览。推广库存、支付和发布能力将在运营模式确定后接入。`)
};

/**
* | output |
* | --- |
* | "I understand that this is a UI-only preview. Campaign inventory, payments, and publishing will be connected after the operating model is finalized." |
*
* @param {Directory_Promotion_AcknowledgementInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_acknowledgement = /** @type {((inputs?: Directory_Promotion_AcknowledgementInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_AcknowledgementInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_acknowledgement(inputs)
	return zh_directory_promotion_acknowledgement(inputs)
});
export { directory_promotion_acknowledgement as "directory.promotion.acknowledgement" }